import { render, staticRenderFns } from "./depth.vue?vue&type=template&id=ff560472&scoped=true&"
import script from "./depth.vue?vue&type=script&lang=js&"
export * from "./depth.vue?vue&type=script&lang=js&"
import style0 from "./depth.vue?vue&type=style&index=0&id=ff560472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff560472",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff560472')) {
      api.createRecord('ff560472', component.options)
    } else {
      api.reload('ff560472', component.options)
    }
    module.hot.accept("./depth.vue?vue&type=template&id=ff560472&scoped=true&", function () {
      api.rerender('ff560472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/view/depth.vue"
export default component.exports